import { useSyncExternalStore } from "react"

export const PHONE_MEDIA_QUERY = "(max-width: 767px)"

function phoneQuery(): MediaQueryList | null {
    if (
        typeof window === "undefined" ||
        typeof window.matchMedia !== "function"
    )
        return null
    return window.matchMedia(PHONE_MEDIA_QUERY)
}

function subscribe(onChange: () => void): () => void {
    const query = phoneQuery()
    if (!query) return () => {}
    query.addEventListener("change", onChange)
    return () => query.removeEventListener("change", onChange)
}

function readIsPhone(): boolean {
    return phoneQuery()?.matches ?? false
}

function readServerIsPhone(): boolean {
    return false
}

export function useIsPhone(): boolean {
    return useSyncExternalStore(subscribe, readIsPhone, readServerIsPhone)
}
